import React from "react";
import { Redirect } from "react-router-dom";
import { useAuthContext } from "../../contexts/Auth";

export const Logout = () => {
  const {onSignOut} = useAuthContext();
  onSignOut();
  return <Redirect to="/Login" />
}